<div class="form-group row">
	<div class="col-4">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col-auto">
		<select class="form-control" id="<%= form.name %>_<%= field.name.title %>" name="<%= field.name.title %>">
			<option value=""></option>
			<option value="Dr.">Dr.</option>
			<option value="Ifj.">Ifj.</option>
			<option value="Id.">Id.</option>
			<option value="Prof.">Prof.</option>
			<option value="Özv.">Özv.</option>
		</select>
	</div>
	<div class="col">
		<input type="text" class="form-control" placeholder="vezetéknév" id="<%= form.name %>_<%= field.name.last %>" name="<%= field.name.last %>" value="<%= form.data[field.name.last] %>" />
	</div>
	<div class="col">
		<input type="text" class="form-control" placeholder="utónév" id="<%= form.name %>_<%= field.name.first %>" name="<%= field.name.first %>" value="<%= form.data[field.name.first] %>" />
	</div>
	<div class="col">
		<input type="text" class="form-control" placeholder="útónév" id="<%= form.name %>_<%= field.name.middle %>" name="<%= field.name.middle %>" value="<%= form.data[field.name.middle] %>" />
	</div>
</div>
